module.exports = __webpack_public_path__ + "img/logo-pruvo-text.612c3431.png";